module.exports = __webpack_public_path__ + "img/new_logo_bg.1b834da8.png";